var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.7002 13.2621V4.0802C1.7002 2.76576 2.76576 1.7002 4.0802 1.7002H13.6002C14.9146 1.7002 15.9802 2.76576 15.9802 4.0802V10.7881L12.0808 7.22718C11.9405 7.10119 11.7244 7.11353 11.5993 7.25468L8.71253 10.5117L6.96189 8.61093C6.83237 8.4691 6.61116 8.46262 6.47358 8.59665L1.7002 13.2621ZM6.46024 6.46033C7.21135 6.46033 7.82024 5.85144 7.82024 5.10033C7.82024 4.34922 7.21135 3.74033 6.46024 3.74033C5.70914 3.74033 5.10024 4.34922 5.10024 5.10033C5.10024 5.85144 5.70914 6.46033 6.46024 6.46033ZM6.69657 9.32866L1.76416 14.1503C2.01247 15.1995 2.95519 15.9801 4.08024 15.9801H12.8247L6.69657 9.32866ZM9.17572 11.015L13.7454 15.9764C14.9923 15.9015 15.9803 14.8665 15.9803 13.6008V11.7095L11.8814 7.96235L9.17572 11.015ZM5.78029 5.10041C5.78029 5.47596 6.08473 5.78041 6.46029 5.78041C6.83584 5.78041 7.14029 5.47596 7.14029 5.10041C7.14029 4.72486 6.83584 4.42041 6.46029 4.42041C6.08473 4.42041 5.78029 4.72486 5.78029 5.10041Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImage);
export default __webpack_public_path__ + "static/media/ic_image.83f3359350411b124ddb30d793ef7a8d.svg";
export { ForwardRef as ReactComponent };